import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import { CheckBox, DateBox, Template } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import { Icon } from "@iconify/react/dist/iconify.js";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import TabPanel, { Item } from "devextreme-react/tab-panel";

const containerStyle = {
  width: "100%",
  height: "400px",
};

export default function AssetDispatchComponent() {
  const navigate = useNavigate();
  const [state, setState] = useState({
    isStatusUpdated: false,
    isStatusUpdateModalOpen: false,
    isTrackingModalOpen: false,
    isSelected: false,
    rowData: null,
    jobDate: null,
    fromCoords: 0,
    toCoords: 0,
    selectedTabIndex: 0,
  });
  const [errors, setErrors] = useState({
    jobDateValidation: "",
  });
  const [assetDispatchDataSourceLst, setAssetDispatchDataSourceLst] = useState(
    []
  );
  const [arrowPoints, setArrowPoints] = useState([]);
  const [activeMarker, setActiveMarker] = useState(null);
  const [activeMarkerInfo, setActiveMarkerInfo] = useState(null);
  const refDataGrid = useRef(null);
  const user = useSelector((state) => state.user.data);
  const [isOpen, setIsOpen] = useState(false);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Dispatch`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetDispatchLst(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetDispatchLst = async (assetDispatchId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetDispatch(assetDispatchId);
      setAssetDispatchDataSourceLst(
        response.data?.filter(
          (f) => f.statusId !== Number(AssetSubStatus.AssetDispatchJobEnded)
        ) ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const isValidStatusData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.jobDateValidation = "";
      if (state.isSelected && !state.jobDate) {
        isValid = false;
        err.jobDateValidation = `${
          state.rowData?.statusId ===
          Number(AssetSubStatus.AssetDispatchPending)
            ? "Please select job start date."
            : state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted)
            ? "Please select job end date."
            : ""
        }`;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpdateStatus = async (e) => {
    e.preventDefault();
    try {
      if (isValidStatusData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>${
          state.rowData?.statusId ===
          Number(AssetSubStatus.AssetDispatchPending)
            ? `Are you sure want to change status for asset dispatch - [${state.rowData?.dispatchIndentNo}] from pending to job started?`
            : state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted)
            ? `Are you sure want to change status for asset dispatch - [${state.rowData?.dispatchIndentNo}] from job started to job ended?`
            : ``
        }</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isStatusUpdated: true }));
        let body = {
          assetDispatchId: state?.rowData?.id,
          jobDate:
            moment(state.jobDate)
              .format(DefaultDateFormat.SqlDateTime24Format)
              .toString() ?? "",
          userId: user?.userId,
        };
        debugger;
        const response = await assetService.updateAssetDispatchStatus(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isStatusUpdated: false }));
        if (response?.isSuccess) {
          handleOnCloseStatusUpdateModal();
          await getAssetDispatchLst(0);
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isStatusUpdated: false }));
      console.log(error);
    }
  };

  const handleOnCloseStatusUpdateModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isStatusUpdateModalOpen: false,
        rowData: null,
        jobDate: null,
        isStatusUpdated: false,
        isSelected: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseTrackingModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isTrackingModalOpen: false,
        rowData: null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getLocationName = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve) => {
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          resolve(results[0].formatted_address);
        } else {
          resolve("Unknown Location");
        }
      });
    });
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="id"
              dataSource={assetDispatchDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "before",
                  template: "toolbarRefreshTemplate",
                });
              }}
            >
              <Column
                dataField="id"
                width={
                  assetDispatchDataSourceLst?.filter(
                    (f) =>
                      f.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted) ||
                      f.statusId === Number(AssetSubStatus.AssetDispatchPending)
                  ).length > 0
                    ? 160
                    : 80
                }
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        <span>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Action"
                            className="btn btn-primary btn-sm-1"
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                isStatusUpdateModalOpen: true,
                                rowData: cellData?.data,
                                //jobDate: cellData?.data?.startDate,
                              }));
                            }}
                            hidden={
                              cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchJobEnded)
                            }
                          >
                            <Icon
                              className="iconify-size mr-1"
                              icon="mdi:call-to-action"
                              width="14"
                              height="14"
                            />
                            &nbsp;
                            {cellData?.data?.statusId ===
                            Number(AssetSubStatus.AssetDispatchPending)
                              ? "Start job"
                              : cellData?.data?.statusId ===
                                Number(AssetSubStatus.AssetDispatchJobStarted)
                              ? "End Job"
                              : ""}
                          </button>
                        </span>
                        &nbsp;&nbsp;
                        <span>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Track"
                            className="btn btn-primary btn-sm-1"
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                isTrackingModalOpen: true,
                                rowData: cellData?.data,
                                fromCoords: cellData?.data?.fromGeoLocation
                                  ?.split(",")
                                  .map(Number),
                                toCoords: cellData?.data?.toGeoLocation
                                  ?.split(",")
                                  .map(Number),
                              }));
                            }}
                            hidden={
                              cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchPending)
                            }
                          >
                            <i
                              className="fas fa-map-marked-alt"
                              style={{
                                width: "14px",
                                height: "12px",
                                marginTop: "5px",
                              }}
                            ></i>
                            &nbsp;
                            {`${
                              cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchPending)
                                ? "Track"
                                : cellData?.data?.statusId ===
                                  Number(AssetSubStatus.AssetDispatchJobStarted)
                                ? "Replay"
                                : ""
                            }`}
                          </button>
                        </span>
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="movementIndentNo"
                caption="Asset Movement No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="dispatchIndentNo"
                caption="Asset Dispatch No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="dispatchDate"
                caption="Dispatch Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="allocatedAssetName"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.allocatedAssetName || ""} ${
                    data?.allocatedAssetSerialNo || ""
                  } ${data?.materialOrderDesc || ""}`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.materialOrderDesc ? (
                        <>
                          <span>{data?.data?.materialOrderDesc ?? ""}</span>
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.allocatedAssetName ?? ""}</span>
                          {data?.data?.allocatedAssetSerialNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.allocatedAssetSerialNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="categoryName"
                caption="Category"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.categoryName || ""} ${
                    data?.subCategoryName || ""
                  } ${data?.orderSubCategory || ""} ${
                    data?.orderCategory || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.orderSubCategory &&
                      data?.data?.orderCategory ? (
                        <>
                          <span>{data?.data?.orderCategory ?? ""}</span>
                          {data?.data?.orderSubCategory && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.orderSubCategory ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="fromUserFullName"
                caption="From"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromUserFullName || ""} ${
                    data?.fromUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromUserFullName ?? ""}</span>
                      {data?.data?.fromDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toUserFullName"
                caption="To"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toUserFullName || ""} ${
                    data?.toDepartment || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toUserFullName ?? ""}</span>
                      {data?.data?.toDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="fromProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromProjectName || ""} ${
                    data?.toProjectName || ""
                  } ${data?.materialOrderLocation || ""}`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.materialOrderLocation ? (
                        <>
                          <span>{data?.data?.materialOrderLocation ?? ""}</span>
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="transportationName"
                caption="Transportation Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVehicleNo"
                caption="Vehicle No."
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVendorName"
                caption="Vendor Name"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                  ) {
                    color = "#afad1eff";
                  } else if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchJobStarted)
                  ) {
                    color = "#16b36aff";
                  } else if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchJobStarted)
                  ) {
                    color = "#c50a23ff";
                  }

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                    </div>
                  );
                }}
              />
              <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.createdDate || ""} ${
                    data?.createdByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedDate"
                caption="Last updated"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.updatedDate || ""} ${
                    data?.updatedByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.updatedDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.updatedDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.updatedDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.updatedByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getAssetDispatchLst(0);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                // displayMode="compact"
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Asset Dispatch" />
            </DataGrid>
          </div>
        </div>
      </div>

      {/* For Updating Status For Asset Dispatch */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isStatusUpdateModalOpen}
        onAfterOpen={async () => {
          let err = { ...errors };
          err.jobDateValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-medium"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Update Status For Asset Dispatch"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Update Status For Asset Dispatch - [${state.rowData?.dispatchIndentNo}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseStatusUpdateModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <CheckBox
                  value={state?.isSelected}
                  text={`${
                    state.rowData?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                      ? "Is Job Started?"
                      : state.rowData?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ? "Is Reached At Destination?"
                      : ""
                  }`}
                  disabled={false}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      isSelected: e.value ?? false,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            {state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted) && (
              <>
                <div className="col-12 col-lg-6">
                  <div className="form-group mb-2">
                    <label>Job Start Date</label>
                    <DateBox
                      type="datetime"
                      className="form-control"
                      name="jobDate"
                      placeholder={DefaultDateFormat.DateTime24Format}
                      displayFormat={DefaultDateFormat.DateTime24Format}
                      showAnalogClock={true}
                      useMaskBehavior={false}
                      defaultValue={state.rowData?.startDate}
                      value={state.rowData?.startDate}
                      disabled={false}
                      readOnly={true}
                      acceptCustomValue={true}
                    />
                  </div>
                </div>
              </>
            )}
            <div
              className={`col-12 col-lg-${
                state.rowData?.statusId ===
                Number(AssetSubStatus.AssetDispatchJobStarted)
                  ? 6
                  : 12
              }`}
            >
              <div className="form-group mb-2">
                <label>
                  {`${
                    state.rowData?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                      ? "Job Start Date"
                      : state.rowData?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ? "Job End Date"
                      : ""
                  }
                  `}
                  &nbsp;<span className="text-danger">*</span>
                  <DateBox
                    type="datetime"
                    className="form-control"
                    name="jobDate"
                    placeholder={DefaultDateFormat.DateTime24Format}
                    displayFormat={DefaultDateFormat.DateTime24Format}
                    showAnalogClock={true}
                    useMaskBehavior={false}
                    defaultValue={state.jobDate}
                    value={state.jobDate}
                    min={
                      state.rowData?.statusId ===
                      Number(AssetSubStatus.AssetDispatchPending)
                        ? moment(state.rowData?.movementApprovalDate).toDate()
                        : state.rowData?.statusId ===
                          Number(AssetSubStatus.AssetDispatchJobStarted)
                        ? moment(state.rowData?.startDate).toDate()
                        : 0
                    }
                    max={moment(new Date()).toDate()}
                    disabled={false}
                    acceptCustomValue={true}
                    onValueChanged={(date) => {
                      setState((prev) => ({
                        ...prev,
                        jobDate: date.value,
                      }));
                    }}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {state.isSelected && (
              <>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Update"
                  onClick={async (e) => {
                    await handleOnUpdateStatus(e);
                  }}
                  disabled={state.isStatusUpdated}
                >
                  <span title="Update">
                    <i
                      className={`fas fa-${
                        state.isStatusUpdated ? `spinner fa-spin` : `check`
                      }`}
                    />
                    &nbsp;&nbsp;Update
                  </span>
                </button>
                &nbsp;&nbsp;
              </>
            )}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              title="Cancel"
              onClick={() => {
                handleOnCloseStatusUpdateModal();
              }}
            >
              <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={state.isTrackingModalOpen}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Tracking Vehicle For Asset Dispatch"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Tracking vehicle - [${state.rowData?.transportVehicleNo}] - for asset dispatch - [${state.rowData?.dispatchIndentNo}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseTrackingModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Asset Name</label>
                <p className="labelvalue">
                  {state.rowData?.allocatedAssetName ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Trailer No</label>
                <p className="labelvalue">{state.rowData?.trailerNo}</p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Current Location</label>
                <p className="labelvalue">NA</p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">From Location</label>
                <p className="labelvalue">
                  {state.rowData?.fromProjectName ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">To Location</label>
                <p className="labelvalue">
                  {state.rowData?.toProjectName ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Last 24 hours kms</label>
                <p className="labelvalue">NA</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Vehicle No</label>
                <p className="labelvalue">
                  {state.rowData?.transportVehicleNo ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Trip No</label>
                <p className="labelvalue">
                  {state.rowData?.dispatchIndentNo ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Start Time</label>
                <p className="labelvalue">
                  {state.rowData?.startDate
                    ? moment(state.rowData?.startDate)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                        )
                        ?.toString()
                    : "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">End Time</label>
                <p className="labelvalue">
                  {state.rowData?.endDate
                    ? moment(state.rowData?.endDate)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                        )
                        ?.toString()
                    : "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">Status</label>
                <p className="labelvalue">
                  {state.rowData?.statusName ?? "NA"}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group mb-2">
                <label className="mb-0">ETA</label>
                <p className="labelvalue">NA</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                {state.fromCoords && state.toCoords ? (
                  <>
                    <LoadScript
                      googleMapsApiKey={
                        process.env.REACT_APP_GOOGLE_MAP_API_KEY
                      }
                      libraries={["geometry"]}
                    >
                      <GoogleMap
                        mapContainerStyle={{
                          width: "100%",
                          height: "400px",
                        }}
                        onLoad={(map) => {
                          const bounds = new window.google.maps.LatLngBounds();
                          bounds.extend({
                            lat: state.fromCoords ? state.fromCoords[0] : 0,
                            lng: state.fromCoords ? state.fromCoords[1] : 0,
                          });
                          bounds.extend({
                            lat: state.toCoords ? state.toCoords[0] : 0,
                            lng: state.toCoords ? state.toCoords[1] : 0,
                          });
                          map.fitBounds(bounds);
                          const path = [
                            {
                              lat: state.fromCoords[0],
                              lng: state.fromCoords[1],
                            },
                            {
                              lat: state.toCoords[0],
                              lng: state.toCoords[1],
                            },
                          ];
                          const totalDistance =
                            window?.google?.maps?.geometry?.spherical?.computeLength(
                              path
                            );
                          const points = [];
                          for (let d = 0; d <= totalDistance; d += 10000) {
                            const point =
                              window?.google?.maps?.geometry?.spherical?.interpolate(
                                path[0],
                                path[1],
                                d / totalDistance
                              );
                            points.push(point);
                          }
                          setArrowPoints(points);
                        }}
                      >
                        <Marker
                          position={{
                            lat: Number(
                              state.rowData?.fromGeoLocation?.split(",")[0]
                            ),
                            lng: Number(
                              state.rowData?.fromGeoLocation?.split(",")[1]
                            ),
                          }}
                          onMouseOver={() => setIsOpen(true)}
                          onMouseOut={() => setIsOpen(false)}
                        >
                          {isOpen && (
                            <InfoWindow
                              position={{
                                lat: Number(
                                  state.rowData?.fromGeoLocation?.split(",")[0]
                                ),
                                lng: Number(
                                  state.rowData?.fromGeoLocation?.split(",")[1]
                                ),
                              }}
                            >
                              <div>{state.rowData?.transportVehicleNo}</div>
                            </InfoWindow>
                          )}
                        </Marker>
                        <Marker
                          position={{
                            lat: Number(
                              state.rowData?.toGeoLocation?.split(",")[0]
                            ),
                            lng: Number(
                              state.rowData?.toGeoLocation?.split(",")[1]
                            ),
                          }}
                        />
                        <Polyline
                          path={[
                            {
                              lat: Number(
                                state.rowData?.fromGeoLocation?.split(",")[0]
                              ),
                              lng: Number(
                                state.rowData?.fromGeoLocation?.split(",")[1]
                              ),
                            },
                            {
                              lat: Number(
                                state.rowData?.toGeoLocation?.split(",")[0]
                              ),
                              lng: Number(
                                state.rowData?.toGeoLocation?.split(",")[1]
                              ),
                            },
                          ]}
                          options={{
                            strokeColor: "#171b16ff",
                            strokeOpacity: 0.4,
                            strokeWeight: 4,
                          }}
                        />
                        {arrowPoints?.map((point, i) => {
                          const position = {
                            lat: point.lat(),
                            lng: point.lng(),
                          };
                          return (
                            <Marker
                              key={i}
                              position={position}
                              icon={{
                                path: window?.google?.maps?.SymbolPath?.CIRCLE,
                                scale: 4,
                                fillColor: "#29c21bff",
                                fillOpacity: 1,
                                strokeWeight: 0,
                              }}
                              onMouseOver={async () => {
                                const name = await getLocationName(
                                  position.lat,
                                  position.lng
                                );
                                setActiveMarker(i);
                                setActiveMarkerInfo({
                                  name,
                                  lat: position.lat,
                                  lng: position.lng,
                                });
                              }}
                              onMouseOut={() => {
                                setActiveMarker(null);
                                setActiveMarkerInfo(null);
                              }}
                              onClick={async () => {
                                const name = await getLocationName(
                                  position.lat,
                                  position.lng
                                );
                                setActiveMarker(i);
                                setActiveMarkerInfo({
                                  name,
                                  lat: position.lat,
                                  lng: position.lng,
                                });
                              }}
                            >
                              {activeMarker === i && activeMarkerInfo && (
                                <InfoWindow
                                  position={position}
                                  onCloseClick={() => {
                                    setActiveMarker(null);
                                    setActiveMarkerInfo(null);
                                  }}
                                >
                                  <div style={{ fontSize: "12px" }}>
                                    <br />
                                    Location Name:&nbsp;
                                    <strong>{activeMarkerInfo.name}</strong>
                                    <br />
                                    Lat:&nbsp;
                                    <strong>{position.lat.toFixed(5)}</strong>
                                    <br />
                                    Lng:&nbsp;
                                    <strong>{position.lng.toFixed(5)}</strong>
                                  </div>
                                </InfoWindow>
                              )}
                            </Marker>
                          );
                        })}
                      </GoogleMap>
                    </LoadScript>
                  </>
                ) : (
                  <>
                    <h6>No Data Found!!</h6>
                  </>
                )}
              </div>
            </div>
          </div>
          {/* <TabPanel
            loop={true}
            width={"100%"}
            height={"80%"}
            animationEnabled={true}
            swipeEnabled={true}
            tabsPosition={"top"}
            stylingMode={"secondary"}
            iconPosition={"top"}
            //itemComponent={TabPanelItem}
            selectedIndex={state.selectedTabIndex}
            onSelectedIndexChange={(index) => {
              try {
                setState((prev) => ({ ...prev, selectedTabIndex: index }));
              } catch (error) {
                console.log(error);
              }
            }}
          >
            <Item title="Dispatch Details" icon="map">
              <>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    
                  </div>
                </div>
              </>
            </Item>
          </TabPanel> */}
        </div>
      </Modal>
    </>
  );
}
